module.exports = __webpack_public_path__ + "media/images/Galerie-black-00ddc9cde9621f9af52eb65932669611.svg";